// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"36c93524","794":"36c93524"}[chunkId] + ".chunk.css";
};